//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import rotateBase64Img from '../lib/rotateImg'
import { mixins } from '../components/mixins'
import { mapMutations, mapGetters } from 'vuex'
const RATIO = 1
export default {
  name: 'SignturePad',
  mixins: [mixins],
  props: {
    configData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      canvas: null,
      context: null,
      canvasOffset: null,
      isDraw: false,
      headStyle: {
        background: '#fff',
        color: '#333333',
        borderBottom: '1px solid #F3F6F7',
        fontWeight: '500'
      },
      dialogConfig: {
        title: '温馨提示',
        okText: '保存',
        cancelText: '关闭'
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.initWindowFuc()
    this.initCanvas()
  },
  methods: {
    ...mapMutations(['setSignImg']),
    initWindowFuc() {
      const resizeWindow = () => {
        this.$vux.loading.show()
        setTimeout(() => {
          this.$vux.loading.hide()
          this.initCanvas()
          window.removeEventListener('resize', resizeWindow, false)
        }, 1000)
      }
      window.addEventListener('resize', resizeWindow, false)
    },
    veriSign() {
      // 获取像素数据
      let rs = false
      const data = this.context.getImageData(0, 0, this.canvasOffset.width * RATIO, this.canvasOffset.height * RATIO).data
      for (let i = 0; i < data.length; i++) {
        if (data[i]) {
          rs = true
          break
        }
      }
      if (rs) {
        return Promise.resolve()
      } else {
        return Promise.reject()
      }
    },
    close() {
      this.$emit('close')
    },
    save() {
      this.veriSign()
        .then(() => {
          this.sure()
        })
        .catch(() => {
          this.$vux.toast.show('请在空白处签名')
        })
    },
    uploadImg(url = this.$api.dstImage) {
      this.$vux.loading.show()
      return new Promise((r, reject) => {
        const img = this.canvas.toDataURL('image/png', 1 / RATIO)
        rotateBase64Img(img, 270).then(res => {
          this.postAjax(url, { image: res })
            .then(rs => {
              const data = {
                // name: rs.data.fileName,
                fileUrl: rs.data.display_url,
                fileName: rs.data.fileName,
                ...this.configData.data
              }
              r(data)
            })
        })
      })
    },
    uploadUserInfo() {
      this.uploadImg(this.configData.postUrl)
        .then(res => {
          this.$vux.loading.hide()
          this.setSignImg(res)
          this.$emit('save', res)
        })
    },
    sure() {
      if (this.configData.save === true) {
        this.$refs.confirm.showConfirm()
          .then(() => {
            this.uploadUserInfo()
          })
          .catch(() => {
            this.uploadImg()
              .then(res => {
                this.$vux.loading.hide()
                this.$emit('save', res)
              })
          })
      } else if (this.configData.save === 'my') {
        this.uploadUserInfo()
      } else {
        this.uploadImg()
          .then(res => {
            this.$vux.loading.hide()
            this.$emit('save', res)
          })
      }
    },
    resetCtx() {
      this.context.clearRect(0, 0, this.canvasOffset.width * RATIO, this.canvasOffset.height * RATIO)
      this.isDraw = false
    },
    initCanvas() {
      this.canvas = this.$refs.canvasRef || document.getElementById('canvas')
      this.canvasOffset = this.canvas.getBoundingClientRect()
      this.context = this.canvas.getContext('2d')
      this.canvas.width = this.canvasOffset.width * RATIO
      this.canvas.height = this.canvasOffset.height * RATIO
    },
    windowToCanvas(x, y) {
      return {
        x: x * RATIO,
        y: y * RATIO
      }
    },
    getTouchPosition(e) {
      const touch = e.changedTouches[0]
      const { left, top } = this.canvas.getBoundingClientRect()
      return this.windowToCanvas(touch.clientX - left, touch.clientY - top)
    },
    move(e) {
      e.preventDefault()
      this.isDraw = true
      const loc = this.getTouchPosition(e)
      this.context.lineTo(loc.x, loc.y)
      this.context.stroke()
    },
    down(e) {
      const loc = this.getTouchPosition(e)
      this.context.beginPath()
      this.context.moveTo(loc.x, loc.y)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/signaturePad.vue